export default "/_next/static/chunks/fonts/Octicons-6b742a230954dc640ba21eb27e44a0c1.ttf";